<div class="data-filter" style="padding: 0px 5px;">
  <label style="margin: 0px; font-weight: bold;">{{label}}</label>
  <select class="form-control form-control-sm" [(ngModel)]="model" (change)="change()" [disabled]="disabled" >
    <option *ngFor="let o of options" [ngValue]="o.value">{{o.label | translate}}</option>
  </select>
</div>